import React from 'react';

import { Locales } from '@ratehub/base-ui';

import withEnglishLocale from '../functions/withEnglishLocale';
import createSPAStaticProps from '../functions/createSPAStaticProps';
import SearchPage from '../components/SearchPage';


function Page() {
    return (
        <SearchPage />
    );
}

const { getStaticPaths, getStaticProps } = createSPAStaticProps({
    locale: Locales.ENGLISH,
    fileName: 'spaSearchEN', // Must match filename use for catch all, i.e. [...spaSearchEN].jsx
    path: '/search',

    options: {
        headerSettings: {
            isHidden: false,
            disableMenu: false,
            enableDropShadow: true,
            enableLanguageLink: true,
        },
        footerSettings: {
            isDisabled: false,
            isPopularContentDisabled: false,
        },
    },
});

export default withEnglishLocale(Page);
export { getStaticPaths, getStaticProps };
